module.exports = __webpack_public_path__ + "img/upload.89c7b1cd.svg";